import React, { Component } from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

import trans from "trans"

import FileInputComponent from 'react-file-input-previews-base64'

import {
    eshopId,
    projectId,
    getProductGallery,
    getTemplateGallery,
    loadTemplateGallery,
} from "app/helpers/api"

import {
    css,
    Grid,
    GridCell,
    Section,
    Div,
    Theme,
    Button,
    Icon,
} from "@bdfx/mergado-ui-kit"

import {
    setTemplatesToStore,
    Templates,
    setGradientsToStore
} from "template-edit/reducers";

import {
    updateInputValue as change,
    initForm
} from "app/reducers/form";

import { URL } from "app/config/api-config";
import { Gradient, ProductGalleryType } from "app/types/model-types";
import { TemplateGalleryType } from "template-edit/components/template-gallery";
import { RouterType, withRouter } from "app/components/routes";
import { AxiosResponse } from "axios";
import { RandomProduct } from "shape-edit/types";
import { getFormName, templateFromGalleryToStore } from "shape-edit/forms/helpers";
import PreviewTemplateSVG from "template-edit/containers/preview-template-svg";
import newTemplate from "template-edit/helpers/newTemplate";
import { selectFormValues } from "app/reducers/form"
import newAlternativeTemplate from "template-edit/helpers/newAlternativeTemplate"
import { TemplateOrAlternativeTemplateType } from "template-edit/undoRedoReducers"

interface Props {
    router: RouterType
    showProductsPreview: boolean
    templates: Templates
    randomProduct: RandomProduct
    setTemplatesToStore: typeof setTemplatesToStore
    setGradientsToStore: typeof setGradientsToStore
    initForm: typeof initForm
    isAlt: boolean
    form: TemplateOrAlternativeTemplateType
    change: typeof change
}

interface State {
    isLoading: boolean
    templateGallery: TemplateGalleryType[]
    productGallery: ProductGalleryType[]
    scrollPos: number
    scrollWidth: number
    clientWidth: number
    columnWidth: number
    columnsCount: number
}

class GallerySlideShow extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            isLoading: false,
            templateGallery: null,
            productGallery: null,
            scrollPos: 0,
            scrollWidth: null,
            clientWidth: null,
            columnWidth: ItemWidthPx,
            columnsCount: 1,
        }
    }

    getGallery = () => {
        getTemplateGallery(1, null, 20)
            .then((response: AxiosResponse<TemplateGalleryType[]>) => {
                this.setState({ templateGallery: response.data })
            })
            .catch(e => console.error('cannot get template gallery'))
    }

    componentDidMount() {
        const { showProductsPreview } = this.props

        window.addEventListener('resize', this.getColumnWidthAndCount)

        const columnsPerRow = this.getColumnWidthAndCount()

        if (showProductsPreview) {
            getProductGallery(columnsPerRow)
                .then((response: AxiosResponse<ProductGalleryType[]>) => {
                    if (response.data.length === 0) {
                        this.getGallery()
                    } else {
                        this.setState({ productGallery: response.data })
                    }
                })
        } else {
            this.getGallery()
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (prevProps && prevProps.showProductsPreview === true && this.props.showProductsPreview === false && !this.state.templateGallery) {
            this.getGallery()
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.getColumnWidthAndCount)
    }

    getColumnWidthAndCount = (): number => {
        const target = document.getElementById('carousel-wrapper')
        if (target) {
            const columnWidth = target.clientWidth ? Math.round(target.clientWidth / Math.floor(target.clientWidth / ItemWidthPx)) : ItemWidthPx
            const columnsCount = Math.round(target.clientWidth / columnWidth)
            target.style.transform = `translate3d(0px, 0px, 0px)`
            this.setState({
                scrollPos: 0,
                clientWidth: target.clientWidth,
                columnWidth: columnWidth,
                columnsCount: columnsCount,
            })

            return columnsCount
        }

        return 1
    }

    handleSelectTemplate = (id: number) => {
        const { isAlt } = this.props

        const formName = getFormName(isAlt)
        const template = isAlt ? newAlternativeTemplate() : newTemplate()
        this.props.initForm(formName, template)
        loadTemplateGallery(id)
            .then((response: AxiosResponse<{ templateGallery: TemplateGalleryType, gradients: Gradient[] }>) => {
                this.props.setGradientsToStore(response.data.gradients)
                templateFromGalleryToStore(response.data.templateGallery)
                this.props.router.navigate(`/eshop/${eshopId}/project/${projectId}/templates/from-gallery`)
            })
            .catch(e => {
                if (e.response.data) {
                    console.error('error', e.response)
                }
            })
    }

    render() {
        const { showProductsPreview, randomProduct, isAlt } = this.props
        const { templateGallery, productGallery, scrollPos, scrollWidth, clientWidth, columnWidth, columnsCount } = this.state
        const stepSize = columnsCount * columnWidth
        const maxPages = Math.round(scrollWidth / clientWidth)
        let pages = []
        for (let i = 0; i < maxPages; i++) {
            pages.push(i)
        }

        const templateGalleryItems = showProductsPreview && productGallery && productGallery.length > 0 ?
            productGallery.map((product: ProductGalleryType) => {
                const nowTimestamp = new Date().getTime()
                const timeStamp = product.template ? new Date(product.template?.updated_at).getTime() : nowTimestamp
                const templateName = product.template?.name || ''
                const elementName = product.elements?.name || ''
                const addParams = product.should_rerender ? '&nocache=1' : ''

                return <GridCell key={`product${product.id}`} className={'carousel-item'}>
                    <Link to={`/eshop/${eshopId}/project/${projectId}/templates/${product.template_id}/edit`} key={'edit'}>
                        <img
                            style={{ position: 'relative' }}
                            className={'shadow-box'}
                            src={`${URL.laravelBase}images?template_id=${product.template_id}&product_id=${product.id}&ts=${timeStamp}${addParams}`}
                        />
                    </Link>
                </GridCell>
            }) : templateGallery ?
                templateGallery.map((o: TemplateGalleryType, idx: number) => <GridCell key={idx} className={'carousel-item'}>
                    <div className="preview">
                        <span className={'clickable'}>
                            <PreviewTemplateSVG templateGallery={o} randomProduct={randomProduct} isAlt={isAlt} />
                        </span>
                        <br />
                    </div>
                    <div className="hover" onClick={() => this.handleSelectTemplate(o.id)}>
                        <Grid style={{ height: "100%" }} valign="center">
                            <GridCell>
                                <Icon type="edit-light" size={20} color={Theme.blue} text={trans("edit")} />
                            </GridCell>
                        </Grid>
                    </div>
                </GridCell>
                ) : <GridCell />

        return (
            <StyledSection
                header={
                    <React.Fragment>
                        <span
                            className={'big-only left-text-span'}>{showProductsPreview ? trans("previews") : trans("template_gallery")}</span>
                    </React.Fragment>
                }
                >
                <StyledSlideShow>
                    <GridCell>
                        <div className={`${scrollPos < 0 ? "clickable" : ""} on-top`} onClick={scrollPos < 0 ? () => {
                            const target = document.getElementById('carousel-wrapper')
                            if (target) {
                                const newScrollPos = (scrollPos + stepSize)
                                target.style.transform = `translate3d(${newScrollPos}px, 0px, 0px)`
                                target.style.transitionDuration = '150ms'
                                this.setState({
                                    scrollPos: newScrollPos,
                                    clientWidth: target.clientWidth,
                                    scrollWidth: target.scrollWidth
                                })
                            }
                        } : undefined}>
                            <Icon type={'chevron-left-light'} size={40} color={scrollPos < 0 ? Theme.steelblue : "#ddd"} />
                        </div>
                    </GridCell>

                    <GridCell style={{ overflow: 'hidden' }}>
                        <CarouselDiv id={'carousel-wrapper'} columnWidth={columnWidth} maxHeight={250}>
                            {templateGalleryItems}
                            {showProductsPreview && productGallery && productGallery.length > 0 &&
                                <GridCell className={'carousel-item'}>
                                    <StyledNextPreviewsLink to={`/eshop/${eshopId}/project/${projectId}/previews`}>
                                        <Icon color={"blue"} style={{ marginTop: "10px" }} size={30} type="arrow-circle-o-right" />
                                        <br />
                                        {trans('more_previews')}
                                    </StyledNextPreviewsLink>
                                </GridCell>
                            }
                        </CarouselDiv>
                    </GridCell>

                    <GridCell>
                        {(!scrollWidth || -scrollPos + stepSize < scrollWidth - 10) &&
                            <div className={'clickable on-top'} onClick={() => {
                                const target = document.getElementById('carousel-wrapper')
                                if (target) {
                                    const newScrollPos = (scrollPos - stepSize)
                                    target.style.transform = `translate3d(${newScrollPos}px, 0px, 0px)`
                                    target.style.transitionDuration = '150ms'
                                    this.setState({
                                        scrollPos: newScrollPos,
                                        scrollWidth: target.scrollWidth,
                                        clientWidth: target.clientWidth
                                    })
                                }
                            }}>
                                <Icon type={'chevron-right-light'} size={40} color={Theme.steelblue} />
                            </div>
                        }

                    </GridCell>

                    {/*<GridCell col={'1/-1'}>
                    {scrollWidth && clientWidth &&
                    pages.map(p => <span className={'page-item'} key={p}>
                        <Icon type={'circle'} size={10} color={Theme.steelblue} />
                    </span>)
                    }
                </GridCell>*/}
                </StyledSlideShow>
            </StyledSection>
        )
    }
}

const ItemWidthPx = 200

const StyledSlideShow = css(Grid)({
    ".shadow-box": {
        boxShadow: "2px 2px 7px rgba(0,0,0,0.25) !important",
    },
    ' .clickable': {
        cursor: 'pointer',
    },
    minHeight: "208px",
    ' .muk-gridcell': {
        textAlign: 'center',
        alignSelf: 'center',
    },

    gridTemplateColumns: `50px auto 50px`,
    ' .on-top': {
        zIndex: 99999,
    }
})

const CarouselDiv = css(Grid)({
    gridAutoFlow: 'column',
    gridRow: '1',
    transitionDuration: '150ms',
    ' img': {
        maxWidth: '180px',
        maxHeight: '180px',
        margin: '10px',
        objectFit: 'cover',
    },
    ".carousel-item": {
        position: "relative",
        overflow: "visible",
    },
    ".template-name": {
        fontSize: "26px",
        fontWeight: "bold",
        padding: "10px",
        display: "block",
    },
    ".preview": {

    },
    ".hover": {
        background: "rgba(0,0,0,0.2)",
        margin: '12px',
        position: "absolute",
        color: "white",
        left: "10px",
        right: "10px",
        top: "0px",
        bottom: "0px",
        textAlign: "center",
        opacity: 0,
        transition: "all 0.2s",
        cursor: "pointer",
        borderRadius: '2%',
        ":hover": {
            opacity: 1,
            boxShadow: "2px 2px 10px rgba(0,0,0,0.75)"
        },
        ".muk-icon__text": {
            fontSize: "18px",
            fontWeight: "bold",
        },
    }
}, props => {
    return {
        gridAutoColumns: `${props.columnWidth}px`,
        ' .carousel-item': {
            width: `${props.columnWidth}px`,
            maxHeight: `${props.maxHeight}px`,
            overflow: 'hidden',
        },
        '@media screen and (max-width: 600px)': {
            gridTemplateColumns: 'auto',
        },

    }
})

const StyledSection = css(Section)({
    " > .muk-grid": {
        gridTemplateRows: '42px',
        overflow: 'hidden',
    },
    " .m-suffix": {
        padding: '0px',
        height: 'auto',
    },
    " .m-header": {
        height: 'auto',
    },
    " .m-header-content": {
        padding: '0px 20px !important',
    },
    " .left-text-span": {
        lineHeight: '40px',
    },
    " #new-template-button": {
        padding: '14px',
        background: Theme.green,
        ":hover": {
            background: "#5f911d",
        },
        fontWeight: 'bold',
    },
    " #new-template-button.scrolled": {
        position: 'fixed',
        zIndex: 999,
        top: "85px",
        right: '5px',
        padding: '12px 16px',
        borderRadius: Theme.radius,
    }
})


const StyledNextPreviewsLink = css(Link)({
    // fontSize: '20px',
    fontWeight: 'bold',
    whiteSpace: 'pre-line',
    textDecoration: 'none !important',
})

function mapStateToProps(state) {
    return {
        templates: state.templates,
        exportTemplates: state.exportTemplates,
        isAlt: state.isAlt,
        form: selectFormValues(state, getFormName(state.isAlt)),
        randomProduct: state.randomProduct,
    }
}

export default connect(mapStateToProps, {
    setTemplatesToStore,
    setGradientsToStore,
    initForm,
    change,
})(withRouter(GallerySlideShow))
